// extracted by mini-css-extract-plugin
export var root = "MarkdownHeading-module--root--01c0e";